const apiVersion = '/api/v1';

export default ($axios) => ({
    getHeroBanner() {
        return $axios.$get(`${apiVersion}/home/heroBanner?limit=10`);
    }
});
